import { getErrorMessageMapping } from '../config/error-messages';

/**
 * Maps a technical error message to a user-friendly validation message.
 *
 * @param technicalMessage - The technical error message from the API
 * @returns The user-friendly message if a mapping exists, otherwise returns the original message
 */
export const mapErrorMessage = (technicalMessage: string, field?: string): string => {
  const mappedMessage = getErrorMessageMapping(technicalMessage, field);
  return mappedMessage || technicalMessage;
};
